import { StyleSheet } from 'react-native';
import Theme from 'Theme';

const baseStyles = {
    container: {
        flex: 1,
        alignSelf: 'stretch',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: Theme.primaryBackgroundColor,
        paddingHorizontal: Theme.primaryMargin
    },
    successIcon: {
        height: 100,
        width: 100,
        marginBottom: 16
    },
    successTitle: {
        fontFamily: Theme.regularFont,
        color: Theme.primaryTextColor,
        fontSize: 25,
        marginBottom: 50,
        textAlign: 'center'
    },
    successButton: {
        marginBottom: 10
    },
    backdrop: {
        backgroundColor: 'rgba(0,0,0,0.7)'
    }
};

export default StyleSheet.create(baseStyles);
